<!-- eslint-disable vue/max-len -->
<template>
  <svg
    :class="`color-stroke-${color}`"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C13.0506 22 14.0909 21.7976 15.0615 21.4043C16.0321 21.0111 16.914 20.4347 17.6568 19.7081C18.3997 18.9815 18.989 18.1189 19.391 17.1696C19.793 16.2203 20 15.2027 20 14.1752V9.82459C20.0001 7.90233 19.2768 6.04729 17.968 4.61328"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 11.5615V14.175C3.99946 15.7154 4.46376 17.2216 5.33471 18.505C6.20565 19.7884 7.4445 20.7918 8.89598 21.3895"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9999 3.04831C14.1624 2.01072 11.9789 1.72954 9.9295 2.26662C7.88012 2.80369 6.1328 4.11504 5.07191 5.91218C4.63508 6.65011 4.32686 7.454 4.15991 8.29092"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.168 6.53806C11.7564 6.41857 12.3648 6.42979 12.9483 6.5709C13.5317 6.712 14.0754 6.9794 14.5391 7.35337C15.0028 7.72734 15.3748 8.19835 15.6276 8.73166C15.8805 9.26498 16.0077 9.847 15.9999 10.4348V12.9544"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.9759 16.2408C14.4315 16.834 13.7149 17.2503 12.9219 17.4341C12.129 17.618 11.2975 17.5605 10.5389 17.2695C9.78023 16.9785 9.13056 16.4677 8.67681 15.8056C8.22306 15.1436 7.98689 14.3617 7.9999 13.5647V10.4348C7.99686 9.89734 8.10573 9.36487 8.3199 8.86987"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M12 10.6069V13.2204" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>

<script setup lang="ts">
interface icon {
  color?: string;
}

withDefaults(defineProps<icon>(), {
  color: 'black',
});
</script>
